import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Если пользователь уже авторизован — перенаправляем
  if (user) {
    navigate('/', { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(username, password);
      // После успешного login() user уже в контексте
      // Небольшая задержка чтобы React успел обновиться
      setTimeout(() => navigate('/', { replace: true }), 50);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Ошибка входа. Проверьте логин и пароль';
      setError(msg);
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern"></div>
      
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <span className="logo-icon">🛡️</span>
              <h1>Диспетчер</h1>
            </div>
            <p className="login-subtitle">Система управления охраняемыми объектами</p>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message" role="alert">
                <span className="error-icon">⚠️</span>
                <span>{error}</span>
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                <span className="label-icon">👤</span>
                Логин
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={handleKeyDown}
                required
                autoFocus
                autoComplete="username"
                placeholder="Введите логин"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <span className="label-icon">🔒</span>
                Пароль
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                required
                autoComplete="current-password"
                placeholder="Введите пароль"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className={`btn-login ${loading ? 'btn-loading' : ''}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="btn-spinner"></span>
                  <span>Вход...</span>
                </>
              ) : (
                <>
                  <span>🔓</span>
                  <span>Войти</span>
                </>
              )}
            </button>
          </form>
          
          <div className="login-footer">
            <p>Версия 0.2.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
